import React, { useState, useEffect, useRef } from "react";
import Typography from "../components/Typography";
import { spacing, borderRadius } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";
import { motion } from "framer-motion";

function TimeSlider({ timeframe, setTimeframe }) {
    const { theme } = useTheme();
    const TIMEFRAMES = ["1D", "5D", "1M", "6M", "1Y", "3Y", "5Y"];

    const styles = {
        container: {
            display: "flex",
            justifyContent: "center",
            padding: spacing.m,
            backgroundColor: theme.colors.fillPrimary,
            borderRadius: "4px",
            boxSizing: "border-box",
        },
        sliderFrame:{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            width: "100%",
            height: "32px",
            padding: spacing.xs,
            backgroundColor: theme.colors.fillSecondary,
            borderRadius: borderRadius.s,
        }
    }
  
    return (
        <div style={styles.container}>
        <div style={styles.sliderFrame}>
                {TIMEFRAMES.map((frame) => (
                <button
                    key={frame}
                    onClick={() => setTimeframe(frame)}
                    style={{
                    padding: spacing.xxxs,
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                    width: "100%",
                    background: timeframe === frame ? "#222222" : "transparent",
                    color: timeframe === frame ? "#fff" : theme.colors.contentPrimary,
                    fontWeight: timeframe === frame ? "bold" : "normal",
                    transition: "all 0.2s ease-in-out",
                    position: "relative",
                    }}
                >
                    <Typography variant="credit" type="editorial">{frame}</Typography>

                    {timeframe === frame && (
                    <motion.div
                        layoutId="activeIndicator"
                        style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderRadius: "8px",
                        backgroundColor: "#222222",
                        zIndex: -1,
                        }}
                    />
                    )}
                </button>
                ))}
            </div>
        </div>
      
    );
  }
  
export default TimeSlider;